import Modal from '../ui/Modal';
import Button from '../ui/Button';
import EstadoActivoPill from './EstadoActivoPill';

function VisualizarPresupuestoModal({ isOpen, onClose, presupuesto }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Detalle del presupuesto"
      description="Información completa del registro"
      size="md"
      footer={
        <Button variant="secondary" onClick={onClose}>
          Cerrar
        </Button>
      }
    >
      <dl className="divide-y divide-white/5 overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03]">
        <div className="flex items-center justify-between gap-4 px-4 py-3 sm:px-5">
          <dt className="text-[11px] font-mono uppercase tracking-[0.18em] text-white/45">
            Código
          </dt>
          <dd className="font-mono text-sm text-white/90">
            {presupuesto?.cdPresupuesto}
          </dd>
        </div>
        <div className="flex items-center justify-between gap-4 px-4 py-3 sm:px-5">
          <dt className="text-[11px] font-mono uppercase tracking-[0.18em] text-white/45">
            Presupuesto
          </dt>
          <dd className="text-right text-sm font-medium text-white/90">
            {presupuesto?.dePresupuesto}
          </dd>
        </div>
        <div className="flex items-center justify-between gap-4 px-4 py-3 sm:px-5">
          <dt className="text-[11px] font-mono uppercase tracking-[0.18em] text-white/45">
            Estatus
          </dt>
          <dd>
            <EstadoActivoPill status={presupuesto?.stPresupuesto} />
          </dd>
        </div>
      </dl>
    </Modal>
  );
}

export default VisualizarPresupuestoModal;